var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout1',{attrs:{"is-demo":""}},[_c('h1',{staticClass:"text-h4"},[_vm._v("Assets and Products")]),_c('AssetsCardStarter',{staticClass:"pa-0 py-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }